<template>
  <footer class="footer">
    <div class="container">
        <div class="copyright text-center">
          &copy; {{ new Date().getFullYear() }} <a href="https://espressolabs.com.br" target="_blank">Viva Ok</a>
        </div>
    </div>
  </footer>

</template>
<script>
export default {}

</script>
<style>

</style>
